var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getHighlightingModeIsEnabled)?_c('div',{attrs:{"data-component":"highlighting-alert"},on:{"click":_vm.click}},[_c('p',[_vm._v(" Highlighting mode is turned on. Click here to turn it off. ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }